import React, { useContext, useEffect } from 'react'
import { useLazyQuery } from '@apollo/client'
import AutocompleteComponent from '../../../components/filters/AutocompleteComponent'
import { GET_BRANDS_FILTER } from '../../../queries/factory'
import { FactoryFiltersContext } from '../../../context/FactoryFiltersContext'

export default function Brands (): JSX.Element {
  const { filters, setFilters } = useContext(FactoryFiltersContext)
  const [getData, { data }] = useLazyQuery(
    GET_BRANDS_FILTER, {
      notifyOnNetworkStatusChange: true
    }
  )

  useEffect(() => {
    if (filters.factory) {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { brands, ...rest } = filters
      getData({
        variables: { filters: { ...rest } }
      })
    }
  }, [filters])

  const onChange = (value: string[]) => {
    setFilters({
      brands: value
    })
  }

  const brands: string[] = []
  data?.aggregation?.aggregations?.brands?.buckets.map((brand: any) => {
    brands.push(brand.key)
  })

  const typographLabel = 'Brands'
  return (
    <AutocompleteComponent
      labelValue={typographLabel}
      data={brands}
      defaultValues={filters?.brands}
      onChange={onChange}
    />
  )
}
